module.exports = __webpack_public_path__ + "img/tc.c93e0330.svg";